module.exports = __webpack_public_path__ + "img/gq2.34ac6ddc.jpg";